import { clientAuth as client } from './axios';

const login = (body: any) => client.post(`/api/v1/users/login`, body);
const getProfile = () => client.get(`/api/v1/users/me`);

export default {
  login,
  getProfile,
};
